<h2 mat-dialog-title>Confirm</h2>
<div mat-dialog-content>
  <p>{{displayText}}</p>
</div>
<mat-dialog-actions class="actions" align="end">
  <button class="button button--muted button--xs" (click)="onNoClick()">No</button>
  <button class="button button--green-fill button--xs" (click)="onYesClick()">Yes</button>
</mat-dialog-actions>
